var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"editable-cell-renderer"},[_c('div',[_vm._v(_vm._s(_vm.localParams.value))]),_c('div',{staticClass:"edit-pencil"},[_c('SIcon',{staticClass:"mr-1",attrs:{"name":"edit-interface-structure"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }